<div class="selected-users">
  <ng-container *ngFor="let user of userSearchSelectionService.selectedUsers$ | async">
    <app-pencil-pill
      [image]="user.profile_image ?? ''"
      [icon]="user.profile_image ? '' : 'person'"
      [text]="user.name ?? user.email"
      (remove)="removeUser(user)"
      class="user-pill"
    ></app-pencil-pill>
  </ng-container>
</div>

<app-pencil-button
  *ngIf="
    !((userSearchSelectionService.selectedUsers$ | async) ?? []).length &&
    !isSearchFocused &&
    (this.searchQuerySubject$ | async) === ''
  "
  class="pencil-button small white placeholder-btn"
  (clickEvent)="isSearchFocused = true"
>
  <app-pencil-icon name="add" [type]="IconTypes.materialIcon"></app-pencil-icon>
  <span>{{ placeholder }}</span>
</app-pencil-button>

<app-pencil-button
  [class.no-margin]="((userSearchSelectionService.selectedUsers$ | async) ?? []).length === 0"
  icon="add"
  [iconConfig]="{
    type: IconTypes.materialIcon
  }"
  *ngIf="
    !isSearchFocused &&
    (this.searchQuerySubject$ | async) === '' &&
    ((userSearchSelectionService.selectedUsers$ | async) ?? []).length
  "
  class="pencil-button add-btn"
  (clickEvent)="isSearchFocused = true"
></app-pencil-button>

<input
  #userSearch
  [class.no-margin]="((userSearchSelectionService.selectedUsers$ | async) ?? []).length === 0"
  type="search"
  class="search-input"
  *ngIf="isSearchFocused || (this.searchQuerySubject$ | async) !== ''"
  [focus]="true"
  [ngModel]="this.searchQuerySubject$ | async"
  autocomplete="off"
  (focus)="isSearchFocused = true"
  (blur)="onBlurSearch()"
  [style.width.px]="searchTextBoxWidth$ | async"
  (input)="onInputChange($event.target.value)"
  (keydown)="invokeNavigationWithArrowKeys($event)"
  appUserSearchInput
/>
<div
  *ngIf="
    isSearchFocused &&
    ((userSearchDirective?.filteredUsers$ | async)?.length > 0 ||
      (isValidEmail$ | async) ||
      (userSearchDirective?.isLoading$ | async))
  "
  class="suggest-users-container"
>
  <div
    *ngIf="userSearchDirective?.isLoading$ | async; else searchResultsBlock"
    class="search-loading-row"
    aria-hidden="true"
  >
    <app-pencil-spinner [diameter]="18" [strokeWidth]="3"></app-pencil-spinner>
  </div>
  <ng-template #searchResultsBlock>
    <div
      *ngIf="(userSearchDirective?.filteredUsers$ | async)?.length === 0 && (isValidEmail$ | async)"
      class="search-result-option"
    >
      <div class="suggestion-item" (mousedown)="onEmailClick()">
        <div class="user-photo">
          <app-pencil-icon [name]="'person'" [type]="IconTypes.materialIcon"></app-pencil-icon>
        </div>
        <div class="user-info">
          <span
            class="name"
            [innerHTML]="
              this.searchQuerySubject$ | async | highlighter: (this.searchQuerySubject$ | async)
            "
          ></span>
          <span class="more-info">{{ 'Add email as filter' | translate }}</span>
        </div>
      </div>
    </div>
    <div
      *ngFor="
        let user of userSearchDirective?.filteredUsers$ | async;
        trackBy: trackById;
        let userIndex = index
      "
      class="search-result-option"
      #searchResultOption
      role="button"
      (mousedown)="selectUser(user)"
      [class.focused]="focusedUserIndex === userIndex"
    >
      <div class="suggestion-item">
        <img
          alt="profile pic"
          [src]="user?.profile_image"
          *ngIf="user?.profile_image"
          class="user-photo"
        />
        <div *ngIf="user && !user.profile_image" class="user-photo">
          <app-pencil-icon [name]="'person'" [type]="IconTypes.materialIcon"></app-pencil-icon>
        </div>
        <div class="user-info">
          <span
            class="name"
            [innerHTML]="
              (user?.institution === currentUser?.institution?._id ? user?.name : user?.email)
                | highlighter: (this.searchQuerySubject$ | async)
            "
          >
          </span>
          <span *ngIf="user?.institution === currentUser?.institution?._id" class="more-info">
            {{ user?.email }}
          </span>
          <span *ngIf="user?.institution !== currentUser?.institution?._id" class="more-info">
            {{ 'Outside your institution' | translate }}</span
          >
        </div>
      </div>
    </div>
  </ng-template>
</div>
